import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: no-preference)';

/**
 * Custom hook that determines if the user prefers reduced motion.
 *
 * This hook uses the `prefers-reduced-motion` media query to detect the user's preference
 * for reduced motion and updates the state accordingly.
 *
 * @returns {boolean} - A boolean value indicating whether the user prefers reduced motion.
 */
export const useReducedMotion = () => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(true);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(QUERY);
    setPrefersReducedMotion(!window.matchMedia(QUERY).matches);

    const listener = (event: MediaQueryListEvent) => {
      setPrefersReducedMotion(!event.matches);
    };

    mediaQueryList.addEventListener('change', listener);

    return () => {
      mediaQueryList.removeEventListener('change', listener);
    };
  }, []);

  return prefersReducedMotion;
};
